import { render } from "./ResponderFormulario.vue?vue&type=template&id=37dafc64&scoped=true"
import script from "./ResponderFormulario.vue?vue&type=script&lang=js"
export * from "./ResponderFormulario.vue?vue&type=script&lang=js"

import "./ResponderFormulario.vue?vue&type=style&index=0&id=37dafc64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37dafc64"]])

export default __exports__